import { CombineDiscountWithField } from "./fields/combine-discount-with-field";
import { CustomerEligibilityField } from "./fields/customer-eligibility-field";
import { DynamicRangeExpirationField } from "./fields/dynamic-range-expiration-field";
import { DynamicRangePercentageField } from "./fields/dynamic-range-percentage-field";
import { LimitOncePerCustomerField } from "./fields/limit-once-per-customer-field";
import { MinimumPurchaseAmountField } from "./fields/minimum-purchase-amount-field";
import { MinimumQuantityField } from "./fields/minimum-quantity-field";
import { PurchaseTypeField } from "./fields/purchase-type-field";
import { TotalUsesField } from "./fields/total-uses-field";
import { DiscountSettingsSectionProps } from "./types";

export function DynamicRangeSettings({
  formState,
}: DiscountSettingsSectionProps) {
  return (
    <>
      <DynamicRangePercentageField
        max={formState.dynamicRangeMaxPercentage}
        min={formState.dynamicRangeMinPercentage}
        setMax={formState.setDynamicRangeMaxPercentage}
        setMin={formState.setDynamicRangeMinPercentage}
      />
      <DynamicRangeExpirationField
        setUnits={formState.setDynamicRangeExpirationUnits}
        setValue={formState.setDynamicRangeExpirationValue}
        units={formState.dynamicRangeExpirationUnits}
        value={formState.dynamicRangeExpirationValue}
      />
      <CombineDiscountWithField
        setValue={formState.setCombineDiscountWith}
        showProductDiscounts
        showShippingDiscount
        value={formState.combineDiscountWith}
      />
      <MinimumQuantityField
        setValue={formState.handleSetMinimumQuantity}
        value={formState.minimumQuantity}
      />
      <MinimumPurchaseAmountField
        setValue={formState.handleSetMinimumSubtotal}
        value={formState.minimumSubtotal}
      />
      <CustomerEligibilityField
        eligibility={formState.customerEligibility}
        onSegmentChange={formState.handleShopifySegmentChange}
        segmentOptions={formState.ShopifySegmentOptions}
        selectedCustomerIds={formState.selectedCustomerIds}
        selectedSegmentOptions={formState.selectedShopifySegmentOptions}
        setEligibility={formState.setCustomerEligibility}
        setSelectedCustomerIds={(customerIds) => {
          formState.setSelectedCustomerIdsString(customerIds.join(", "));
        }}
      />
      <TotalUsesField
        perCode={formState.perCodeDiscount}
        setUnlimited={formState.setUnlimitedUsage}
        setValue={formState.setTotalUsageLimit}
        unlimited={formState.unlimitedUsage}
        value={formState.totalUsageLimit}
      />
      <LimitOncePerCustomerField
        setValue={formState.setAppliesOncePerCustomer}
        value={formState.appliesOncePerCustomer}
      />
      <PurchaseTypeField
        purchaseType={formState.purchaseType}
        recurringCycleLimit={formState.recurringCycleLimit}
        setPurchaseType={formState.setPurchaseType}
        setRecurringCycleLimit={formState.setRecurringCycleLimit}
      />
    </>
  );
}
